'use strict';

(function () {
  'use strict';
  // an element to contain the help information

  angular.module('msCore').component('msInfoButton', {
    bindings: {
      infoTitle: '<',
      infoText: '<',
      infoHtml: '<',
      infoAriaLabel: '<'
    },
    templateUrl: 'core/templates/infoButton.html',
    controller: ['$scope', infoToggleCtrl]
  });

  function infoToggleCtrl($scope) {
    var vm = this;
    vm.$onInit = _activate;

    function _activate() {
      vm.isVisible = false;
    }

    vm.toggleInfo = function () {
      vm.isVisible = !vm.isVisible;
    };

    vm.closeInfo = function (elId) {
      if (vm.isVisible && elId === $scope.$id) {
        vm.isVisible = false;
      }
    };
  }
})();